export default defineAppConfig({
  ui: {
    colors: {
      primary: 'amber',
      neutral: 'stone',
    },
    input: {
      slots: {
        root: 'w-full',
      },
      defaultVariants: {
        variant: 'soft' as const,
        size: 'lg' as const,
      },
    },
    textarea: {
      slots: {
        root: 'w-full',
      },
      defaultVariants: {
        variant: 'soft' as const,
        size: 'lg' as const,
      },
    },
    select: {
      slots: {
        base: 'w-full',
      },
      defaultVariants: {
        variant: 'soft' as const,
        size: 'lg' as const,
      },
    },
  },
});
